import React, { useState } from 'react';
import Select from 'react-select';

interface Props {
    className?: string;
    style?: React.CSSProperties;
    isMultiSelect?: boolean;
    isClearable?: boolean;
    data: any;
    placeholder?: string;
    label?: string;
    onSelect?: (e: any) => void;
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;
    selectedItems?: any;
    name?: any;
    errorMessage?: any;
    Option?: any;
    hideSelectedOptions?: boolean;
    isSearchable?: boolean;
    enablePagination?: boolean;
    hasMore?: boolean;
    isLoading?: boolean;
    onLoadMore?: () => void
}

const DropDownV2 = (props: Props) => {
    const [isFocused, setIsFocused] = useState(false);

    const getBoxClass = () => {
        if (props?.errorMessage) return 'input-field-error';
        if (isFocused) return 'input-field-focused';
        return '';
    };

    const handleScrollToBottom = () => {
        if (props?.enablePagination && props?.hasMore && !props?.isLoading) {
            props?.onLoadMore?.();
        }
    };

    return (
        <div className={`input-field-wrapper ${props?.className || ''}`}>

            {/* Label — identical to InputFieldV2 */}
            {props?.label && (
                <div className="input-field-label-row">
                    <label className="input-field-label" htmlFor={props?.name}>
                        {props?.label}
                    </label>
                </div>
            )}

            {/* Box — identical to InputFieldV2, menu anchors here */}
            <div
                style={props?.style}
                className={`input-field-box dropdown-box ${getBoxClass()} ${props?.isMultiSelect ? 'dropdown-box--multi' : ''}`}
            >
                <Select
                    inputId={props?.name}
                    placeholder={props?.placeholder}
                    isMulti={props?.isMultiSelect}
                    isClearable={props?.isClearable}
                    name={props?.name}
                    options={props?.data}
                    classNamePrefix="select"
                    onChange={props?.onSelect}
                    value={props?.selectedItems}
                    closeMenuOnSelect={props?.isMultiSelect ? false : true}
                    onFocus={(e) => { setIsFocused(true); props?.onFocus?.(e); }}
                    onBlur={(e) => { setIsFocused(false); props?.onBlur?.(e); }}
                    components={props?.Option}
                    hideSelectedOptions={props?.hideSelectedOptions ? false : true}
                    isSearchable={props?.isSearchable}
                    menuPosition="absolute"   // keeps menu inside the box's stacking context
                    menuShouldScrollIntoView={false}
                    unstyled                  // strip all react-select defaults

                    // Pagination enabled only when requested
                    {...(props?.enablePagination
                        ? {
                            onMenuScrollToBottom: handleScrollToBottom,
                            isLoading: props?.isLoading ?? false,
                        }
                        : {})}
                />
            </div>

            {/* Error — identical to InputFieldV2 */}
            {props?.errorMessage && (
                <span className="input-field-error-text">{props.errorMessage}</span>
            )}
        </div>
    );
};

export default DropDownV2;